import request from '@/utils/request'

// 获取列表
export function list (params) {
  return request({
    url: '/product/productseries/list',
    method: 'get',
    params: params
  })
}

// 获取信息
export function info (params) {
  return request({
    url: '/product/productseries/info',
    method: 'get',
    params: params
  })
}

// 添加
export function add (params) {
  return request({
    url: '/product/productseries/save',
    method: 'post',
    data: params
  })
}

// 修改
export function update (params) {
  return request({
    url: '/product/productseries/update',
    method: 'post',
    data: params
  })
}

// 删除
export function del (params) {
  return request({
    url: '/product/productseries/delete',
    method: 'post',
    data: params
  })
}

//获取体系名称下拉
export function hierarchyInfo () {
    return request({
        url: '/product/productseries/hierarchyInfo',
        method: 'get',
    })
}
//获取应用行业下拉
export function industryInfo () {
  return request({
    url: '/product/productseries/industryInfo',
    method: 'get',
  })
}